import { render, staticRenderFns } from "./ReceiveForm.vue?vue&type=template&id=1578aa05&scoped=true"
import script from "./ReceiveForm.vue?vue&type=script&lang=js"
export * from "./ReceiveForm.vue?vue&type=script&lang=js"
import style0 from "./ReceiveForm.vue?vue&type=style&index=0&id=1578aa05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1578aa05",
  null
  
)

export default component.exports